import * as types from "./actionTypes";

// Action dispatchers

export const getAddressList = (postCode) => ({
  type: types.GET_ADDRESS_LIST,
  postCode,
});

export const storeAddressList = (addressList) => ({
  type: types.STORE_ADDRESS_LIST_IN_APP,
  payload: addressList,
});

export const postcodeSetError = (error) => ({
  type: types.POSTCODE_ERROR_SET,
  payload: error,
});

export const postcodeClearError = () => ({
  type: types.POSTCODE_ERROR_CLEAR,
});
